import {action, observable, runInAction} from "mobx";
import {IArenaGameFilterEditorViewModel} from "./arena-game-filter-editor-view-model.interface";
import {IArenaGameFilter} from "./arena-game-filter.interface";

export class ArenaGameFilterEditor implements IArenaGameFilterEditorViewModel {
    constructor(private readonly arenaGameFilter: IArenaGameFilter) {
        this._on = arenaGameFilter.isApplied;
    }

    get id(): string {
        return this.arenaGameFilter.id;
    }

    @observable.ref
    private _on: boolean;
    get on(): boolean {
        return this._on;
    }

    set on(value: boolean) {
        runInAction(() => this._on = value);
    }

    @action.bound
    toggleFilter(): void {
        this.on = !this.on;
    }


    get text(): string {
        return this.arenaGameFilter.text;
    }

    get shouldBeDisplayed(): boolean {
        return !this.arenaGameFilter.isDynamicFilter;
    }
}